import React, { useState, useEffect } from "react";
import api from "../../api";
import { FetchPendingList } from "../../services/pendingService";
import { FetchOnboardedList } from "../../services/onboardedService";
import { FetchRejectedList } from "../../services/rejectedService";
import { FetchScreeningList } from "../../services/screeningService";
import { FetchScheduledList } from "../../services/scheduledService";
import { FetchOnholdList } from "../../services/onholdService";
import { FetchSelectedList } from "../../services/selectedService";
import { toast } from "react-toastify";
import { decryptDataFromArray } from "helpers/EncDec";
import { PieChart, Pie, Cell, Tooltip, Legend } from "recharts";
import { GetJobList } from "../../services/JobService";
import { getUserToken } from "helpers/authHelper";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useTranslation } from "react-i18next";

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <div style={tooltipStyles}>
        <div style={arrowStyles} />
        <p>{`${payload[0].name} : ${payload[0].value}`}</p>
      </div>
    );
  }

  return null;
};
const tooltipStyles = {
  backgroundColor: "#ffffff",
  borderRadius: "10px",
  border: "1px solid #7C879A",
  padding: "10px 10px 0 10px",
  position: "relative",
  color: "#000",
  fontSize: "10px",
};

const arrowStyles = {
  width: 0,
  height: 0,
  borderLeft: "8px solid transparent",
  borderRight: "8px solid transparent",
  borderTop: "8px solid #ffffff",
  position: "absolute",
  bottom: "-8px", // Position it at the bottom of the tooltip
  left: "50%",
  transform: "translateX(-50%)",
  zIndex: 1,
};

// CSS styles for the tooltip and arrow

export default function DemographicChart(props) {
  const { t } = useTranslation();
  const [selectedState, setSelectedState] = useState("");
  const [selectedJob, setSelectedJob] = useState("");
  const [states, setStates] = useState([]);
  const [jobs, setJobs] = useState([]);
  const [data, setData] = useState([]);
  let type = props?.type;
  let startDate = props?.startDate;
  let endDate = props?.endDate;
  const history = useHistory();
  const getStateGenderData = async (stateId, jobId) => {
    api
      .get(
        `${process.env.REACT_APP_API_URL}/admin/common/getStatewisePieChartData?stateId=${stateId}&jobId=${jobId}&type=${type}&startDate=${startDate}&endDate=${endDate}`,
      )
      .then(response => {
        let responseData = response?.data;
        responseData = decryptDataFromArray(responseData);

        let data = responseData?.data;
        setData(data);
      })
      .catch(err => {});
  };

  const handleStateChange = event => {
    const id = event.target.value;
    setSelectedState(id);
    getStateGenderData(id, selectedJob);
    //updateChartData(selectedOption, selectedFilter, event.target.value);
  };
  const handleJobChange = event => {
    const id = event.target.value;
    setSelectedJob(id);
    getStateGenderData(selectedState, id);
  };

  const fetchStateData = () => {
    api
      .get(`${process.env.REACT_APP_API_URL}/admin/location/state-list`)
      .then(response => {
        const allState = response.data;
        const dataDecrypt = decryptDataFromArray(allState);

        if (Array.isArray(dataDecrypt?.data)) {
          setStates(dataDecrypt?.data);
        }
      })
      .catch(err => {});
  };

  const fetchJobList = async () => {
    let language_id = localStorage.getItem("lang_id");
    if (language_id) {
      GetJobList()
        .then(res => {
          let response = decryptDataFromArray(res.data);

          if (response?.status) {
            setJobs(response?.data);
          }
        })
        .catch(err => {
          toast.error("No data Available");
        });
    }
  };

  useEffect(() => {
    if (type !== "custom") {
      getStateGenderData("", "");
    } else {
      if (!startDate || !endDate) {
        setData(null); // Set data to null if dates are not selected
      } else {
        getStateGenderData("", "");
      }
    }
  }, [type]);

  useEffect(() => {
    if (startDate !== "" && endDate !== "") {
      getStateGenderData("", "");
    }
  }, [startDate, endDate]);

  useEffect(() => {
    // getStateGenderData("", "");
    fetchStateData();
    fetchJobList();
  }, []);

  const pieColors1 = ["#FF6384", "#36A2EB", "#FFCE56"];
  const pieColors2 = ["#FF6384", "#36A2EB", "#FFCE56", "#4BC0C0", "#9966FF"];
  const genderData = [
    { name: t(`Gender.Male`), value: data?.malePercentage || 0 },
    { name: t(`Gender.Female`), value: data?.femalePercentage || 0 },
    { name: t(`Gender.Others`), value: data?.othersPercentage || 0 },
  ];
  const ageData = [
    { name: "<20", value: data?.ageBelow20Percentage || 0, ageGroup: "18,19" },
    { name: "20-29", value: data?.age20To29Percentage || 0, ageGroup: "20,29" },
    { name: "30-39", value: data?.age30To39Percentage || 0, ageGroup: "30,39" },
    { name: "40-49", value: data?.age40To49Percentage || 0, ageGroup: "40,49" },
    { name: "50+", value: data?.ageAbove50Percentage || 0, ageGroup: "51,100" },
  ];

  const CustomLegend = ({ payload, colors }) => {
    return (
      <ul className="custom-legend">
        {payload.map((entry, index) => (
          <li key={`item-${index}`}>
            <span
              className="legend-color"
              style={{ backgroundColor: colors[index % colors.length] }}
            />
            {entry.value}
          </li>
        ))}
      </ul>
    );
  };

  return (
    <div className="vacancy-tabel last-chart-card">
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <div className="eligible-content gap-3">
              <h3 className="d-flex align-items-center gap-2 heading-one w-100">
                {t(`Dashboard.Demographic Distribution`)}
              </h3>
              <div className="dropdown-container w-100">
                {/* <label htmlFor="state-options" className="me-2">
                  States:
                </label> */}
                <select
                  id="state-options"
                  value={selectedState}
                  onChange={handleStateChange}
                  className="form-select"
                >
                  <option value="">{t(`Dashboard.All States`)}</option>
                  {states.map(state => (
                    <option key={state.id} value={state.id}>
                      {state.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="dropdown-container w-100">
                {/* <label htmlFor="job-options" className="me-2">
                  Jobs:
                </label> */}
                <select
                  id="job-options"
                  value={selectedJob}
                  onChange={handleJobChange}
                  className="form-select"
                >
                  <option value="">{t(`Dashboard.All Jobs`)}</option>
                  {jobs.map(job => (
                    <option key={job.id} value={job.id}>
                      {job.title}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="chart-container pt-2">
              {data && data.malePercentage !== null ? (
                <div className="chart-box">
                  <h5 className="text-start">
                    {t(`Dashboard.Gender Distribution`)}
                  </h5>

                  <div className="cards-section mt-3 ">
                    <PieChart width={400} height={400}>
                      <Pie
                        data={genderData}
                        cx={200}
                        cy={200}
                        outerRadius={150}
                        fill="#8884d8"
                        dataKey="value"
                      >
                        {genderData.map((entry, index) => (
                          <Cell
                            key={`cell-${index}`}
                            fill={pieColors1[index % pieColors1.length]}
                            onClick={() => {
                              history.push(
                                `/all-applications?gender=${entry?.name}&filterValue=true`
                              );
                            }}
                          />
                        ))}
                      </Pie>
                      <Tooltip content={<CustomTooltip />} />
                      <Legend
                        content={
                          <CustomLegend
                            payload={genderData}
                            colors={pieColors1}
                          />
                        }
                      />
                    </PieChart>
                  </div>
                </div>
              ) : (
                <div className="no-data data-available">
                  <img
                    src="../img/data-not-available.png"
                    alt="data not availble"
                  />
                  <h3>{t(`Dashboard.No Item Found`)}</h3>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: t(`Dashboard.No Item Msg`),
                    }}
                  ></p>
                </div>
              )}
              {data && data.age20To29Percentage !== null ? (
                <div className="chart-box">
                  <h5 className="text-start">
                    {t(`Dashboard.Age Group Distribution`)}
                  </h5>

                  <div className="cards-section mt-3">
                    <PieChart width={400} height={400}>
                      <Pie
                        data={ageData}
                        cx={200}
                        cy={200}
                        outerRadius={150}
                        fill="#8884d8"
                        dataKey="value"
                      >
                        {ageData.map((entry, index) => (
                          <Cell
                            key={`cell-${index}`}
                            fill={pieColors2[index % pieColors2.length]}
                            onClick={() => {
                              history.push(
                                `/all-applications?age=${entry?.ageGroup}&filterValue=true`
                              );
                            }}
                          />
                        ))}
                      </Pie>
                      <Tooltip content={<CustomTooltip />} />
                      <Legend
                        content={
                          <CustomLegend payload={ageData} colors={pieColors2} />
                        }
                      />
                    </PieChart>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
